import { doGet, doPost } from './FetchWrapper';

export const list = () => {
    return doGet(`/api/?event=role.list`);
};


